import {
    IShowOptions,
    ColorPickerItemType,
    ColorStyleType,
    ISingleColorUnit,
    IItemList,
    ILumItem,
} from '@src/js/common/ark-extensions/dc-components/color-picker/type';
import i18n from 'i18next';
import { STSchemeColorVal } from '@tencent/slide-sdk-pb-model/src/ultrabuf/ultrabuf.types';

export const EditPaletteStandardColor: ISingleColorUnit[] = [
    {
        color: '#C00000',
        tip: i18n.t('标准深红'),
    },
    {
        color: '#FF0000',
        tip: i18n.t('标准红'),
    },
    {
        color: '#FFC000',
        tip: i18n.t('标准橙'),
    },
    {
        color: '#FFFF00',
        tip: i18n.t('标准黄'),
    },
    {
        color: '#92D050',
        tip: i18n.t('标准浅绿'),
    },
    {
        color: '#00B050',
        tip: i18n.t('标准绿'),
    },
    {
        color: '#00B0F0',
        tip: i18n.t('标准浅蓝'),
    },
    {
        color: '#0070C0',
        tip: i18n.t('标准蓝'),
    },
    {
        color: '#002060',
        tip: i18n.t('标准深蓝'),
    },
    {
        color: '#7030A0',
        tip: i18n.t('标准紫'),
    },
];

export const EditPaletteGradualColor: ISingleColorUnit[] = [
    {
        color: 'linear-gradient(225deg, #002060 0%, #7030A0 100%)',
        tip: i18n.t(''),
    },
    {
        color: 'rgba(123, 33, 33, 1)',
        tip: i18n.t(''),
    },
];

export const GradualMenuItemList: IItemList = [
    {
        itemType: ColorPickerItemType.Color,
        payload: {
            styleName: ColorStyleType.EditPalette,
            theme: 'theme',
            label: i18n.t('纯色填充'),
        },
    },
];

export const StandardMenuItemList: IItemList = [
    {
        itemType: ColorPickerItemType.Color,
        payload: {
            styleName: ColorStyleType.EditPalette,
            theme: 'theme',
            label: '',
        },
    },
    {
        itemType: ColorPickerItemType.Color,
        payload: {
            styleName: ColorStyleType.EditPalette,
            theme: 'standard',
            label: i18n.t('标准色'),
            colors: EditPaletteStandardColor,
        },
    },
    {
        itemType: ColorPickerItemType.Color,
        payload: {
            styleName: ColorStyleType.Recent,
            label: i18n.t('最近使用'),
            maxShowNum: 10,
        },
    },
    {
        itemType: ColorPickerItemType.MenuDivider,
    },
    {
        itemType: ColorPickerItemType.Custom,
        payload: {
            label: i18n.t('更多颜色'),
        },
    },
];

export const BaseOptions: IShowOptions = {
    rowSpan: 10,
    size: 20,
    style: {
        paddingBottom: '8px',
    },
};

// 标准pc模版
export const StandardPCOptions: IShowOptions = Object.assign(BaseOptions, {
    itemList: StandardMenuItemList,
});

// 主题原色
const firstThemeLum = [
    {
        lumMod: undefined,
        lumOff: undefined,
    },
    {
        lumMod: undefined,
        lumOff: undefined,
    },
    {
        lumMod: undefined,
        lumOff: undefined,
    },
    {
        lumMod: undefined,
        lumOff: undefined,
    },
    {
        lumMod: undefined,
        lumOff: undefined,
    },
    {
        lumMod: undefined,
        lumOff: undefined,
    },
    {
        lumMod: undefined,
        lumOff: undefined,
    },
    {
        lumMod: undefined,
        lumOff: undefined,
    },
    {
        lumMod: undefined,
        lumOff: undefined,
    },
    {
        lumMod: undefined,
        lumOff: undefined,
    },
];

/*
 主题发光配置
 从office观察得出，对于不同主题色系，色盘会计算出不同的发光参数
 发光参数并不存于ooxml中，问了下chatgpt，目测应该是软件行为
 根据观察，目前存在5种发光配置，分辨为白色（接近白色）、黑色（接近黑色）、浅色（接近彩色）、深色（接近彩色）、彩色
 */

// 白色发光
export const whiteThemeLum = [
    {
        lumMod: 95000,
        lumOff: undefined,
        tips: i18n.t('5%'),
    },
    {
        lumMod: 85000,
        lumOff: undefined,
        tips: i18n.t('15%'),
    },
    {
        lumMod: 75000,
        lumOff: undefined,
        tips: i18n.t('25%'),
    },
    {
        lumMod: 65000,
        lumOff: undefined,
        tips: i18n.t('35%'),
    },
    {
        lumMod: 50000,
        lumOff: undefined,
        tips: i18n.t('50%'),
    },
];

// 黑色发光
export const blackThemeLum = [
    {
        lumMod: 50000,
        lumOff: 50000,
        tips: i18n.t('50%'),
    },
    {
        lumMod: 65000,
        lumOff: 35000,
        tips: i18n.t('35%'),
    },
    {
        lumMod: 75000,
        lumOff: 25000,
        tips: i18n.t('25%'),
    },
    {
        lumMod: 85000,
        lumOff: 15000,
        tips: i18n.t('15%'),
    },
    {
        lumMod: 95000,
        lumOff: 5000,
        tips: i18n.t('5%'),
    },
];

// 浅色发光
export const lightThemeLum = [
    {
        lumMod: 90000,
        lumOff: undefined,
        tips: i18n.t('10%'),
    },
    {
        lumMod: 75000,
        lumOff: undefined,
        tips: i18n.t('25%'),
    },
    {
        lumMod: 50000,
        lumOff: undefined,
        tips: i18n.t('50%'),
    },
    {
        lumMod: 25000,
        lumOff: undefined,
        tips: i18n.t('75%'),
    },
    {
        lumMod: 10000,
        lumOff: undefined,
        tips: i18n.t('90%'),
    },
];

// 深色发光
export const darkThemeLum = [
    {
        lumMod: 10000,
        lumOff: 90000,
        tips: i18n.t('90%'),
    },
    {
        lumMod: 25000,
        lumOff: 75000,
        tips: i18n.t('75%'),
    },
    {
        lumMod: 50000,
        lumOff: 50000,
        tips: i18n.t('50%'),
    },
    {
        lumMod: 75000,
        lumOff: 25000,
        tips: i18n.t('25%'),
    },
    {
        lumMod: 90000,
        lumOff: 10000,
        tips: i18n.t('10%'),
    },
];

// 彩色发光
export const colorThemeLum = [
    {
        lumMod: 20000,
        lumOff: 80000,
        tips: i18n.t('80%'),
    },
    {
        lumMod: 40000,
        lumOff: 60000,
        tips: i18n.t('60%'),
    },
    {
        lumMod: 60000,
        lumOff: 40000,
        tips: i18n.t('40%'),
    },
    {
        lumMod: 75000,
        lumOff: undefined,
        tips: i18n.t('25%'),
    },
    {
        lumMod: 50000,
        lumOff: undefined,
        tips: i18n.t('50%'),
    },
];

export const THEME_KEY = [
    STSchemeColorVal.dk1,
    STSchemeColorVal.lt1,
    STSchemeColorVal.dk2,
    STSchemeColorVal.lt2,
    STSchemeColorVal.accent1,
    STSchemeColorVal.accent2,
    STSchemeColorVal.accent3,
    STSchemeColorVal.accent4,
    STSchemeColorVal.accent5,
    STSchemeColorVal.accent6,
    STSchemeColorVal.hlink,
    STSchemeColorVal.folHlink,
];

